import { render, staticRenderFns } from "./ViewOrderCard.vue?vue&type=template&id=5341d329&scoped=true"
import script from "./ViewOrderCard.vue?vue&type=script&lang=js"
export * from "./ViewOrderCard.vue?vue&type=script&lang=js"
import style0 from "./ViewOrderCard.vue?vue&type=style&index=0&id=5341d329&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341d329",
  null
  
)

export default component.exports